import type { MenuPopoverState } from "@fluentui/react-components";
import {
  makeStyles,
  mergeClasses,
  useMenuPopoverStyles_unstable,
  shorthands,
} from "@fluentui/react-components";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { HighContrastSelector } from "@fluentui/react";
import { customTokens } from "@1js/acui-theme";
import { useV9MenuEnabled } from "../../hooks/useNextComponentsEnabled";

const useMenuPopoverContainerStyles = makeStyles({
  root: {
    ...shorthands.borderRadius("8px"),
    ...shorthands.padding("6px", "0px"),
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    maxWidth: "none",
    minWidth: "none",
    maxHeight:
      "calc(100vh - 50px)" /* The max height of the context menu should be the space available on the screen without the floatie(40px) and padding (~8px) */,
    backgroundColor: customTokens.colorNeutralBackground1,
    boxShadow: customTokens.shadow16,
  },
  highContrast: {
    [`${HighContrastSelector}`]: {
      ...shorthands.borderStyle("solid"),
    },
  },
  borderFix: {
    ...shorthands.border("0px"),
    [`${HighContrastSelector}`]: { ...shorthands.border("1px") },
  },
});

const useRibbonMenuPopoverContainerStyles = makeStyles({
  rootMultiLine: {
    maxHeight:
      "calc(100vh - 170px)" /* The max height of the Ribbon menu should be the space available on the screen without the ribbon and padding from statusbar */,
  },
  rootSingleLine: {
    maxHeight:
      "calc(100vh - 137px)" /* The max height of the Ribbon menu should be the space available on the screen without the ribbon and padding from statusbar */,
  },
});
export const useAppMenuPopoverStyles = (
  state: MenuPopoverState,
  isRightClickMenu?: boolean,
  ribbonMode?: "SingleLine" | "Multiline"
) => {
  const isV9MenuEnabled = useV9MenuEnabled();
  const isV9RibbonMenu = isV9MenuEnabled && !isRightClickMenu;
  const styles = useMenuPopoverContainerStyles();
  const ribbonMenuStyles = useRibbonMenuPopoverContainerStyles();
  const isMultilineRibbon = ribbonMode === "Multiline";
  state.root.className = mergeClasses(
    styles.root,
    isV9RibbonMenu && isMultilineRibbon && ribbonMenuStyles.rootMultiLine,
    isV9RibbonMenu && !isMultilineRibbon && ribbonMenuStyles.rootSingleLine,
    styles.highContrast,
    styles.borderFix,
    state.root.className
  );
  useMenuPopoverStyles_unstable(state);
  return state;
};
